module.exports = __webpack_public_path__ + "static/media/syss.2cd414b9.png";